import React, { Component } from "react";
import Select from "views/pages/Select";
import Overlay, { Header, Content } from "views/pages/Overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./styles/styles.css";
import DefaultModal from "views/pages/Modal";
import { toggleLabelOverlay } from "store/ConfigurationSettings/LanguageConfig/actions";
import { useDispatch } from "react-redux";
import { setLabelCategory } from "store/ConfigurationSettings/LanguageConfig/actions";
import { onChangeNewLabelKey } from "store/ConfigurationSettings/LanguageConfig/actions";
import { onChangeNewLabelValue } from "store/ConfigurationSettings/LanguageConfig/actions";
import { addNewLabel } from "store/ConfigurationSettings/LanguageConfig/actions";
import { Input } from "reactstrap";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch();
  let language = props.language?.data;
  const languageData = props.languageData;
  let categories = [];

  languageData.defaultLanguage.data &&
    Object.entries(languageData.defaultLanguage.data).map((items, index) => {
      categories.push({ name: items[1][0].categoryName });
    });

  return (
    props.defaultModal && (
      <DefaultModal
        isOpen={props.defaultModal}
        title={language?.settings.add_label}
        selectedTab="addNewLabel"
        size={"md"}
      >
        <Content cn="commboard-content">
          <div className="add-label-form">
            <div className="add-label-select">
              <Select
                options={categories}
                selectedOptions={language.selectedLabel}
                onChange={(e) => dispatch(setLabelCategory(e))}
                valueKey={"name"}
                multi={false}
                placeholder={language?.settings.select_category}
                language={language}
              />
            </div>
            <div className="d-flex pb-3">
              <Input
                type="text"
                className="mr-2"
                placeholder={language?.settings.label_key}
                name="language_key"
                value={props.newLabelKey}
                onChange={(e) => dispatch(onChangeNewLabelKey(e.target.value))}
              />
              <Input
                type="text"
                placeholder={language?.settings.label_value}
                name="language_value"
                value={props.newLabelValue}
                onChange={(e) =>
                  dispatch(onChangeNewLabelValue(e.target.value))
                }
              />
            </div>
            <button
              className="btn  btn-info"
              onClick={() => dispatch(addNewLabel())}
            >
              {language?.settings.add_label}
            </button>
          </div>
        </Content>
      </DefaultModal>
    )
  );
};
